import { useState, useEffect } from 'react';
import { readContextFromHTML } from '../utils/htmlContextUtils';
import { useOpenAIResponses } from './useOpenAIResponses';
import { logger } from '../utils/logger';

export const useChatVDPContext = () => {
  const [vdpContextSent, setVdpContextSent] = useState(false);
  const [htmlContext, setHtmlContext] = useState<any>(null);

  // Function to get VDP context message when needed (only when user sends a message)
  const getVDPContextMessage = (): string | null => {
    if (vdpContextSent) return null;
    
    // CRITICAL: Always read FRESH context on every call - never use stale cache
    const context = readContextFromHTML();
    setHtmlContext(context);
    
    if (context?.shouldSendVDPContext && context?.vdpContextMessage) {
      return context.vdpContextMessage;
    }
    return null;
  };

  // Function to mark VDP context as sent
  const markVDPContextAsSent = () => {
    setVdpContextSent(true);
  };

  return {
    vdpContextSent,
    getVDPContextMessage,
    markVDPContextAsSent,
  };
};